module.exports = __webpack_public_path__ + "static/img/hanhwa-chemical.27b9695.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/hanhwa-chemical.jpg
// module id = TPYX
// module chunks = 0